<template>
    <div id="vipkalameetingdetails" class="container-fluid text-center">
        <Navigator></Navigator>
        <div v-if="$store.state.kalameetingDetails && $store.state.kalameetingDetails.name">
            <div class="row text-center m-3">
                <div class="col col-lg-6 mx-auto card p-5 text-center">
                    <h1>{{$store.state.kalameetingDetails.name}}</h1>
                    <p>By {{$store.state.kalameetingDetails.owner.firstName}}
                        {{$store.state.kalameetingDetails.owner.lastName}}</p>
                        <div>
                            <b-badge v-if="$store.state.kalameetingDetails.availableTickets === 0"
                                     variant="danger" class="p-2">
                                Sold Out
                            </b-badge>
                            <b-badge v-else="meeting.availableTickets < meeting.totalTickets"
                                     class="p-2" variant="primary">
                                {{ $store.state.kalameetingDetails.availableTickets }}
                                / {{ $store.state.kalameetingDetails.totalTickets }}
                                Tickets Available
                            </b-badge>
                        </div>
                    <p class="p-3">
                        {{new Date($store.state.kalameetingDetails.date)
                        .toLocaleDateString()}}<br>
                        {{$store.state.kalameetingDetails.startTime}} -
                        {{$store.state.kalameetingDetails.endTime}}
                    </p>
                    <p>
                        Line Starts:
                        {{new Date($store.state.kalameetingDetails.lineStart).toLocaleDateString()}}
                        {{new Date($store.state.kalameetingDetails.lineStart).toLocaleTimeString()}}
                    </p>
                    <h4>Details</h4>
                    <p>
                        Slot Price: {{$store.state.kalameetingDetails.slotPrice}}<br>
                        Time Slot: {{$store.state.kalameetingDetails.timeSlot}} min<br>
                        Break Time: {{$store.state.kalameetingDetails.breakTime}} min after
                            {{$store.state.kalameetingDetails.slotsInARow}} slots<br>
                    </p>
                    <div>
                        <b-button pill @click="start" class="mt-4 my-2">
                            Start Kalameeting Now</b-button><br><br>
                        <router-link class="col" to="/">Back home</router-link>
                    </div>
            </div>
            </div>
        </div>
    </div>
</template>

<style>
    #vipkalameetingdetails {
        background-image: url("../../assets/images/texture.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-attachment: fixed;
        min-height: 100%;
        min-width: 100%;
    }
</style>

<script>
import Navigator from '../../components/Navigator.vue';

export default {
    components: {
        Navigator
    },
    methods: {
        start() {
            this.$router.push({
                name: 'VIPCameraView', params: { id: this.$route.params.id }
            });
        }
    }
};
</script>
